import pubSub from "checkout-query-client/publish-subcriber/pub-sub";
import { PubSub } from "checkout-query-client/publish-subcriber/types";

let pubSubCache: PubSub;

export const usePubSub = () => {
  if (!pubSubCache) {
    pubSubCache = pubSub();
  }

  return pubSubCache;
};
